import sniffer from 'sniffer'

const store = {
  dom: {
    doc: document.documentElement,
    body: document.body,
    header: document.getElementById('header'),
    scroll: document.querySelector('[data-scroll]'),
  },
  bounds: {
    ww: window.innerWidth,
    wh: window.innerHeight,
    scroll: 0,
    scrollDirection: 'down',
  },
  section: 'home',
  sectionProdId: null,
  resizeFn: null,
  scrollFn: null,
  termsGoTo: null,
  flags: {
    home: false,
    locked: true,
    dropdown: false,
    dropdownForm: false,
    resize: false,
    active: true, // To check weather user changed of tab
    first: true,
    windows: ['Win32', 'Win64', 'Windows', 'WinCE'].indexOf(window.navigator.platform) !== -1,
  },
  cta: true,
}

Object.assign(store, sniffer.getInfos())

store.flags.smooth = store.isDesktop

export default store
